import React from 'react';
import classNames from 'classnames';

import DocumentationPaper from 'cityads-v3/components/DocumentationPaper';

import classes from './DocumentationForm.scss';

type DocumentationFormProps = React.PropsWithChildren<{
  className?: string,
  documentationTitle?: string,
  documentationContent: JSX.Element,
  documentationLink?: string,
}>

export default function DocumentationForm({
  className,
  children,
  documentationTitle,
  documentationContent,
  documentationLink,
  ...rest
}: DocumentationFormProps): JSX.Element {
  return (
    <div className={classNames(classes.wrapper, className)} {...rest}>
      {children ? (
        <div className={classes.formWrapper}>
          {children}
        </div>
      ) : null}
      <DocumentationPaper
        className={classes.documentation}
        title={documentationTitle}
        documentationLink={documentationLink}
      >
        {documentationContent}
      </DocumentationPaper>
    </div>
  );
}
